/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'confluence.error.panel.refresh.app': 'App aktualisieren',
  'confluence.error.panel.reload.page': 'Seite neu laden',
  'confluence.icon.label': 'Symbol',
  'confluence.modal.dialog.close.modal.button': 'Abbrechen',
  'confluence.select.required.field.message': 'Dieses Feld ist ein Pflichtfeld.',
  'confluence.text.area.required.field.message': 'Dieses Feld ist ein Pflichtfeld.',
  'confluence.textfield.validator.email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  'confluence.textfield.validator.number': 'Bitte eine gültige Zahl eingeben',
  'confluence.textfield.validator.required.field.message': 'Dieses Feld ist ein Pflichtfeld.',
  'confluence.textfield.validator.telephone': 'Bitte geben Sie eine gültige Telefonnummer ein.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Zugriff erforderlich',
  'confluence.threeLOPrompt.modal.error.title': 'Fehler',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'Zustimmungs-URL konnte nicht gefunden werden. Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'Zustimmungs-URL konnte nicht gefunden werden. Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Zugriff gestatten',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Zugriff konfigurieren',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Authentifizierung fehlgeschlagen.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'Damit {appString} angezeigt wird, müssen Sie der App erlauben, in Ihrem Namen auf Atlassian-Produkte zuzugreifen.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message-appify':
    'Damit {appString} angezeigt wird, müssen Sie der App erlauben, in Ihrem Namen auf Atlassian-Apps zuzugreifen.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} benötigt zusätzlichen Zugriff auf Ihr Konto.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Externe Authentifizierung – Warnung',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'diese App',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Diese App',
  'confluence.user.group.unknown.user.message': 'Unbekannter Benutzer',
  'confluence.user.picker.empty.field.error.message': 'Dieses Feld ist ein Pflichtfeld.',
  'confluence.user.unknown.user.message': 'Unbekannter Benutzer',
  'forge-ui.form.submit-button.text': 'Senden',
  'forge.modal.deprecation.message':
    'Ihre App {appName} verwendet die veraltete modale Bearbeitungserfahrung für benutzerdefinierte Felder. Diese wird schrittweise eingestellt. Bitten Sie Ihren Systemadministrator, die App auf die Inline-Bearbeitung zu aktualisieren. Falls weiterhin Probleme bestehen, wenden Sie sich an den App-Entwickler.',
  'forge.modal.deprecation.title': 'Ihre App aktualisieren',
};
